export default "__VITE_ASSET__Ot$PDBvp__"